export default __webpack_public_path__ + "media/images/psa-logo-ico-dcb33ea8b4b920e3a15cd87160a3ab54.png";